module.exports = __webpack_public_path__ + "img/al.7711279f.svg";